import React from "react";
import tw from "twin.macro";
import LineChart from "../charts/LineChart";
import watchIndustryArea from "../../data/watchIndustryArea";
import memIndustrial2 from "../../data/memIndustrial2";
import retailArea from "../../data/retailArea";
import healthcareArea from "../../data/healthcareArea";
import ict2 from "../../data/ict2";


const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-6/12 flex-shrink-0 relative`;


const watchIndustryAreaData = {
    label: "",
    data: watchIndustryArea,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const memIndustrial2Data = {
    label: "",
    data: memIndustrial2,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const retailAreaData = {
    label: "",
    data: retailArea,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const healthcareAreaData = {
    label: "",
    data: healthcareArea,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}

const ict2Data = {
    label: "",
    data: ict2,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}



export default ({
                    title = "",
                    d1 = "",
                    d2 = "",
                    d3 = "",
                    d4 = "",
                    d5 = "",
                    d6 = "",
                    d7 = "",
                    strong_desc1= "",
                    strong_desc2= "",
                    image1="",
                }) => {
    return (
        <>
            <h1>{title}</h1>
            <p>
                <strong>{strong_desc1}</strong>
            </p>
            <p>
                <strong>{strong_desc2}</strong>
            </p>
            <div  style={{textAlign:'center',margin:'3% 0% 3% 0%'}}>
                <ImageColumn style={{marginLeft:'auto',marginRight:'auto'}}>
                    <LineChart
                        data={[watchIndustryAreaData]}
                        title="Watch industry area"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart
                        data={[memIndustrial2Data]}
                        title="MEM-industrial"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart
                        data={[retailAreaData]}
                        title="Retail area"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart
                        data={[healthcareAreaData]}
                        title="Healthcare area"
                        legend={false}
                        dateFormat="month"
                    />
                    <LineChart
                        data={[ict2Data]}
                        title="ICT (Information & Communication Technologies)"
                        legend={false}
                        dateFormat="month"
                    />
                    <p>
                        {image1}
                    </p>
                </ImageColumn>
            </div>
            <p>
                {d1}
            </p>
            <p>
                {d2}
            </p>
            <p>
                {d3}
            </p>
            <p>
                {d4}
            </p>
            <p>
                {d5}
            </p>
            <p>
                {d6}
            </p>

        </>
    );
};
